import { useQuery } from "@tanstack/react-query";

import type { ListSkillCollectionsResponse } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export const useListSkillCollections = (workspaceId: number | null) => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";

  return useQuery({
    queryKey: ["skill-collections", workspaceId],
    queryFn: async (): Promise<ListSkillCollectionsResponse> => {
      if (!workspaceId) {
        return { success: true, skill_collections: [] };
      }
      const res = await fetch(ENDPOINTS.skill_collections.list(workspaceId), {
        headers: jsonAuthHeaders(userToken),
      });
      return handleResponse(res);
    },
    enabled: !!workspaceId && !!userToken,
  });
};
